import { useAdminGetUserContacts } from '../../hooks/admin-get-user-contacts.hook';
import { UserContactsTable } from '../Tables/UserContactsTable.component';

type Props = {
  userId: string;
};

export function UserContactsTab({ userId }: Props) {
  const { isLoading, contacts } = useAdminGetUserContacts({ userId });

  return <UserContactsTable contacts={contacts} isLoading={isLoading} ariaLabel="Contacts de l'éco-acteur" />;
}
